import type { FaireProductEntity } from "../../entity_types/product";

export const p_6x6jomb9k5: FaireProductEntity = {
  token: "p_6x6jomb9k5",
  type: "product",
  name: "Hug Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/7b78be85314c3cf91ae1fcf000bd0d8de1d5c41b20895168e1bb16d04cf2566f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07c6ba927a091bb0be01f14777e62aa082ecc66701d1caa6a6c47f5105e777f2.jpeg",
    "https://cdn.faire.com/fastly/e560de26ba1160df307d083751b72a08bc8f9900a15980f7716bdd9d879f08a7.jpeg",
    "https://cdn.faire.com/fastly/7ca8f6716ed36ea2e26eae5612ac06e604a152fdb8075f7491358a51428a3f6a.jpeg",
    "https://cdn.faire.com/fastly/27fc7237698e9377f181757441a8a76edd26c06d08016b2bb12f8fbfaa8323df.webp",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:38.667Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
